import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-noop-page',
    template: '',
    standalone: false
})
export class NoopPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
